<template>
<v-container fill-height  class="d-flex align-start mb-6">
<v-row >

<v-card>
  <v-toolbar
    flat
    color="primary"
    dark
  >
    <v-toolbar-title>User Profile</v-toolbar-title>
  </v-toolbar>
  <v-tabs vertical>
    <v-tab>
      <v-icon left>
        mdi-account
      </v-icon>
      Account
    </v-tab>
    <v-tab>
      <v-icon left>
        mdi-lock
      </v-icon>
      Orders
    </v-tab>
    <v-tab>
      <v-icon left>
        mdi-access-point
      </v-icon>
      Notification
    </v-tab>

    <v-tab-item>
      <v-card flat>
        <v-card-text>
          <p>
            Name: {{loggedInUser.data.firstName + " "+loggedInUser.data.lastName}}
            <br/>
            Email: {{loggedInUser.data.emailAddress}}
            <br/>
            Phone: {{loggedInUser.data.phoneNumber}}
            <br/>
            Location: {{loggedInUser.data.buyerLocation.description}}
            <br/>
          </p>

          
        </v-card-text>
      </v-card>
    </v-tab-item>
    <v-tab-item>
      <v-card flat>
        <v-card-text>
          <!-- order details go here --> 

          Order Details 

          <v-card class="ma-4">
            <v-row>
              <v-list-item 
                v-for="(order, i) in userOrders"
                :key="i.key"
                >
              <v-col cols="5" class="ma-2"> 

                <v-img height="200" width="200" class="ma-4" :src="order.data.imageUrl"/>

              </v-col>

              <v-col cols="5" height="200" width="200" class="ma-2" >
                <div class="order-details ma-4">

                
                <h5>{{order.data.orderItemName}}</h5>
               <h6> {{order.data.ownerQuantity}} x   KES. {{order.data.orderItemPrice}} </h6>
               <h4> Total: KES. {{order.data.totalPrice}}</h4>
               status: Processing
              

               
                <h6>    <v-icon left>
                mdi-pin
                 </v-icon> {{order.data.buyerLocation}}</h6>
                <v-btn color="danger" class="ma-4">  

                  <v-icon left>
                mdi-phone
                 </v-icon>

    Contact Seller</v-btn>

                </div>
              </v-col>
               </v-list-item >
            </v-row>
          </v-card>

          <!-- end of order details --> 
        </v-card-text>
      </v-card>
    </v-tab-item>
    <v-tab-item>
      <v-card flat class="ma-6 text-center"> 
        <p>You have no messages at this time</p>
      </v-card>
    </v-tab-item>
  </v-tabs>
</v-card>

</v-row>
</v-container>
</template>


<script>


export default {
  
created() { 
    this.$store.dispatch("getCurrentUser");
    this.$store.dispatch("getUserOrders");
},
  computed: {
    userEmail: {
      get() {
        return this.$store.state.loggedInEmail;
      },
    },
      userName: {
        get() {
          return this.$store.state.displayName;
        },
       
        },
         loggedInUser: {
          get() 
          { 
          return this.$store.state.loggedInUser[32];
          }
      },
      userOrders: {
        get()
        {
        return this.$store.state.currentUserOrders;
        }
      }
    
  },
  data: () => ({

  }),
  methods: {
/** Todo better than most 
 *  fetch account 
 *  Fetch the product data 
 *  
 * 
*/


  }

}
</script>



// WEBPACK FOOTER //
// src/components/Profile.vue